import styled from 'styled-components';
import Input from '@@Components/Input/Input';
export const NewsletterSubscriptionBoxWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin-bottom: 60px;
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
`;
export const Title = styled.div `
  text-align: center;
  padding: 0 50px;
  font-size: 1.71rem;
  line-height: 2.42rem;
  font-weight: bold;
`;
export const NewsletterSubscriptionBoxInnerContainer = styled.div `
  width: 905px;
  margin: auto;
  @media (max-width: 1000px) { width: 850px }
  ${props => props.theme.mixins.mobile(`
    width: 100%;
  `)}
`;
export const NewsletterInputBox = styled.div `
  display: flex;
  margin-top: 35px;
  div:first-child {
    flex-grow: 2;
  }
  ${props => props.theme.mixins.mobile(`
    flex-flow: column;
    div:first-child {
      margin-bottom: 5px; 
    }
    button { max-width: 100%; }
  `)}
`;
export const StyledInput = styled(Input) `
  height: 42px;
  @media (min-width: 901px) { 
    border-right: none; 
    &:focus {
      border-right: none;
    }
  }
`;
